<template>
  <div class="welcome">
    <DisplayText :screenProperties="screenProperties"></DisplayText>
  </div>

  <!--BUTTONS-->
  <div class="buttons" id="start-buttons">
    <QppButton :buttons="buttons"></QppButton>
  </div>

  <div v-if="qrButton" class="qr-button w3-hide">
    <QppButton :buttons="qrButton" :loaded="qrRead"></QppButton>
  </div>

</template>

<script>
import store from "@/store";
import helper from "@/services/helper";
import DisplayText from "@/components/common/DisplayText";
import QppButton from "@/components/common/QppButton";
import screenApiService from "@/services/screenApiService";
import {mapState} from "vuex";

export default {
  name: 'START_QR',
  components: {DisplayText, QppButton},
  data() {
    return {
      buttons: [],
      screenProperties: {},
      qrButton: [],
      qrRead: false,
      go: '',
    }
  },
  computed: mapState(['toggleText', 'showError']),
  watch: {
    toggleText(newValue) {
      if (store.state.languageId !== store.state.defaultLanguage.id && this.cardNotFound !== '') {
        if (newValue === true) {
          this.getTranslation(store.state.defaultLanguage.id, 'cardNotFound');
          this.getTranslation(store.state.defaultLanguage.id, 'go');
        } else if (newValue === false) {
          this.getTranslation(store.state.languageId, 'cardNotFound');
          this.getTranslation(store.state.languageId, 'go');
        }
      }
    },
    showError(newValue) {
      if (newValue === false) {
        this.checkCard();
      }
    }
  },
  mounted() {
    store.commit('showModal', false);
    this.screenProperties = store.state.currentScreenProperties;
    let buttons = store.state.currentScreenOptions;
    this.qrButton = [buttons[0]];
    buttons.splice(0, 1);
    this.buttons = buttons;

    this.checkInput(); //check QR read input

    helper.sortByKey(this.buttons, 'sortOrder');
    if (document.readyState !== 'loading') {
      setTimeout(this.setlangAnimation, 50);
      setTimeout(this.addHandAnimation, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(this.setlangAnimation, 50);
        setTimeout(this.addHandAnimation, 500);
      });
    }
  },
  beforeUnmount() {
    screenApiService.resetPopup();
    store.commit('showError', false);
    store.state.errorStatus = '';
  },
  methods: {
    setlangAnimation() {
      let firstButton = document.getElementsByClassName('lang-button');
      if (firstButton && firstButton.length > 0) {
        let newAnimation = firstButton[0].classList.contains('new-animation')
        let parentButton = firstButton[0].parentElement;
        parentButton.classList.add('language-animation');
        if (newAnimation) {
          parentButton.classList.add('new-animation');
        }
      }
    },
    addHandAnimation() {
      let startIcon = document.getElementsByClassName('start-button');
      const elem = document.createElement('i');
      if (startIcon && startIcon.length > 0) {
        let parentButton = startIcon[0].parentElement;
        elem.classList.add("fa", "fa-hand-point-right", 'fa-3x', 'white', "hand-pointer-start");
        if (parentButton)
          parentButton.prepend(elem)
      }
    },

    //QR read functions
    checkInput() {
      let typedString = "";
      let app = this;
      document.addEventListener("keypress", function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          // on ENTER
          e.preventDefault();
          app.scanQR(typedString);
          typedString = "";
        } else typedString += e.key;
      });
    },
    scanQR(qrcode) {
      store.state.qrCodeError = false
      console.log("Scanned code: " + qrcode);
      store.commit('setqrCodeData', qrcode);
      this.qrRead = true;
    }
  }
}
</script>
